import React, { useMemo } from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import { MatchingListEmptyState, MatchingListWrapper } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxMatchingList';
import useClaimsCardsList from '@/modules/employer/components/Lockbox/LockboxDetails/hooks/useClaimsCardsList';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import ClaimsList from './components/ClaimsList';
import useExtendClaimsWithMatchingData from './hooks/useExtendClaimsWithMatchingData';

const ViewSelectedClaims = () => {
  const { originalLockbox } = useLockboxDetailsStore();
  const { claimsWithMatchingData, isLoaded } = useExtendClaimsWithMatchingData({ claims: originalLockbox?.createdClaimRepayments });

  const selectedClaims = useMemo(() => {
    if (!isLoaded) {
      return [];
    }

    return claimsWithMatchingData?.map((claimWithMatchingData) => ({
      ...claimWithMatchingData,
      ...originalLockbox?.suggestedClaims?.find((suggestedClaim) => suggestedClaim?.claimId === claimWithMatchingData?.claimId),
    }));
  }, [claimsWithMatchingData, isLoaded, originalLockbox?.suggestedClaims]);

  const { fields } = useClaimsCardsList({ lockboxClaims: selectedClaims });

  return (
    <MatchingListWrapper title="Selected Claims" childrenWrapperProps={{ pad: 'spacing12' }}>
      <ClaimsList
        fields={fields}
        emptyState={(
          <Box>
            {!isLoaded && originalLockbox?.claimRepayments?.length ? (
              <Preloader testId="selected_claims_preloader" />
            ) : (
              <MatchingListEmptyState title="No Search Results" testId="selected-lockbox-claims" />
            )}
          </Box>
        )}
      />
    </MatchingListWrapper>
  );
};

export default ViewSelectedClaims;
